<template>
	<div class="quota">
		<!-- 添加配额 -->
		<div v-if="hiden" class="mask"></div>
		<div class="details" v-if="hiden">
			<div class="details-1">
				{{ title }}
				<i class="el-icon-close" @click="close"></i>
			</div>
			<div style="margin-top: 15px">
				<el-form ref="form" :model="form" label-width="80px" :inline="true" class="demo-form-inline">
					<el-form-item label="配额名称" class="quotaName"><el-input v-model="form.quotaName" class="quotaName_input"></el-input></el-form-item>
					<el-form-item label="限制数量" class="quotaNumber">
						<el-input v-model="form.quotaNumber" @change="judgeNum(form.quotaNumber)" class="quotaNumber_input"></el-input>
					</el-form-item>
					<el-form-item label="配额描述" class="quotaTextarea">
						<el-input type="textarea" rows="3" cols="64" v-model="form.quotaDescribe" class="quotaTextarea_input"></el-input>
					</el-form-item>
					<el-form-item v-for="(item, index) in form.quotaConditionVOS" :key="index" class="quotaTextThree">
						<div class="choiceQuestion">
							<el-select v-model="item.questionsId" placeholder="请选择问题" @change="meth($event, item)" value-key="id">
								<el-option v-for="(item, index) in choQuestion" :key="item.id" :label="'Q' + (index + 1) + ' ' + item.questionsName" :value="item.id"></el-option>
							</el-select>
						</div>
						<div class="choiceCondit">
							<el-select class="choiceCondit_select" v-model="item.quotaCondition" placeholder="请选择条件">
								<el-option v-for="item in item.Condit" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div class="choiceValue">
							<el-select
								v-if="item.questionsType == 8 || item.questionsType == 10 || item.questionsType == 12 || item.questionsType == 9"
								v-model="item.questionsOptionId"
								placeholder="请选择值"
								@change="valueMeth($event, item)"
								value-key="id"
							>
								<el-option v-for="item in item.optionList" :key="item.id" :label="item.labelName" :value="item.id"></el-option>
							</el-select>
							<el-input
								v-if="item.questionsType == 2 || item.questionsType == 3 || item.questionsType == 5"
								v-model="item.quotaValue"
								@change="valueMeth(item.id, item)"
							></el-input>

							<el-input class="choiceValue_input" v-if="item.questionsType == ''"></el-input>
						</div>
						<div style="float: left">
							<i class="icon iconfont iconjian" @click.prevent="removeDomain(item)" style="font-size: 18px; color: #f54b4b; margin-left: 20px"></i>
							<i class="icon iconfont iconjia" @click="addDomain" style="font-size: 18px; color: #999999; margin-left: 18px"></i>
						</div>
					</el-form-item>
					<el-button
						v-if="indexx < 0"
						@click="addDomain"
						style="
              display: block;
              background-color: #0080ff;
              color: #fff;
              margin-left: 78px;
            "
					>
						添加配额
					</el-button>
					<el-form-item style="margin-left: 280px">
						<el-button type="primary" @click="onSubmit">确定</el-button>
						<el-button @click="close">取消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<div class="quota_box">
			<span @click="backQuota()" style="font-size: 18px">
				<i class="el-icon-arrow-left" style="margin-right: 20px"></i>
				配额
			</span>
			<div class="">
				<div v-if="quotaData == ''" class="empty_box">
					<div style="padding-top: 21px">
						<p
							style="
                width: 24px;
                height: 24px;
                border: 1px solid #999;
                text-align: center;
                line-height: 24px;
                margin: 0 auto;
              "
							@click="addQuota()"
						>
							<i class="el-icon-plus"></i>
						</p>
					</div>
					<p
						style="
              text-align: center;
              font-size: 14px;
              color: #666;
              margin-top: 17px;
            "
						@click="addQuota()"
					>
						添加配额
					</p>
				</div>
				<div v-if="quotaData != ''" style="margin-top: 20px">
					<div
						style="
              width: 100%;
              height: 52px;
              background-color: #fff;
              border-bottom: 1px solid #e3e3e3;
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
					>
						<span style="margin-left: 30px; font-size: 14px">共{{ total }}条</span>
						<button
							@click="addQuota()"
							style="
                width: 100px;
                height: 34px;
                background: #0080ff;
                color: #fff;
                border-radius: 3px;
                border: none;
                margin-right: 30px;
              "
						>
							添加配额
						</button>
					</div>
					<el-table :data="quotaData" style="width: 100%">
						<el-table-column align="center" prop="quotaName" label="配额名称" width="180"></el-table-column>
						<el-table-column align="center" prop="quotaDescribe" label="配额描述" width="300"></el-table-column>
						<el-table-column align="center" prop="quotaNumber" label="配额限制量"></el-table-column>
						<el-table-column align="center" prop="accomplishment" label="当前完成量"></el-table-column>
						<el-table-column align="center" label="操作">
							<template slot-scope="scope">
								<i class="icon iconfont iconlianxirenicon-05" @click="edit(scope.row)"></i>
								<i class="icon iconfont iconlianxirenicon-09" @click="delet(scope.row)" style="font-size: 17px; margin-left: 20px"></i>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			quotaData: [], //配额列表数组
			total: 0,
			hiden: false, //弹窗显示或隐藏
			title: '添加配额',
			indexx: 0, // 添加的配额
			form: {
				id: '',
				questionnaireId: '',
				quotaName: '',
				quotaDescribe: '',
				quotaNumber: '',
				quotaConditionVOS: [
					{
						questionsId: '',
						questionsName: '',
						labelName: '',
						questionsOptionId: '',
						questionsType: '',
						quotaCondition: '',
						quotaValue: '', //如果是填空题，存储填空题结果
						optionList: [], // 当前题目的选项
						Condit: [
							{
								label: '大于',
								value: 'ge'
							},
							{
								label: '小于',
								value: 'le'
							},
							{
								label: '等于',
								value: 'eq'
							}
						]
					}
				]
			},
			choQuestion: [] //所有的问题
		};
	},
	created() {},
	mounted() {
		this.wid = sessionStorage.getItem('wid');
		this.loadQuotaListData();
		this.loadAllQuestion();
		console.log('所有问题问题', this.choQuestion);
	},
	methods: {
		edit(row) {
			console.log('编辑', row);
			this.title = '修改配额';
			this.hiden = true;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryQuota}`,
				method: 'POST',
				data: {
					id: row.id
				},
				cb(res) {
					if (res.code == 0) {
						that.form = res.resultBody;
						if (that.form.quotaConditionVOS != null && that.form.quotaConditionVOS.length > 0) {
							for (var i = 0; i < that.form.quotaConditionVOS.length; i++) {
								var q = that.getQuestionById(that.form.quotaConditionVOS[i].questionsId);
								that.initOptionListCondition(that.form.quotaConditionVOS[i], q);
							}
						}
						console.log('配额信息', res);
					}
				}
			};
			this.$util.request(params);
		},
		delet(row) {
			console.log('删除', row);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.delQuota}`,
				method: 'POST',
				data: {
					id: row.id
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success('删除成功！');
						that.loadQuotaListData();
					} else {
						that.$message.error('删除失败！');
					}
				}
			};
			this.$util.request(params);
		},
		valueMeth(optionid, item) {
			var q = this.getQuestionById(item.questionsId);
			for (var i = 0; i < q.optionList.length; i++) {
				if (q.questionsTypeId == 2 || q.questionsTypeId == 3 || q.questionsTypeId == 5) {
					item.questionsOptionId = q.optionList[i].id;
				} else {
					if (optionid == q.optionList[i].id) {
						item.labelName = q.optionList[i].labelName;
					}
				}
			}
		},
		getQuestionById(qid) {
			for (var i = 0; i < this.choQuestion.length; i++) {
				if (qid == this.choQuestion[i].id) {
					return this.choQuestion[i];
				}
			}
		},
		meth(qid, item) {
			console.log('输出选中内容', item);

			var q = this.getQuestionById(qid);
			item.questionsName = q.questionsName;
			item.questionsType = q.questionsTypeId;
			this.initOptionListCondition(item, q);
		},
		initOptionListCondition(item, q) {
			if (q.questionsTypeId == 8 || q.questionsTypeId == 10 || q.questionsTypeId == 12 || q.questionsTypeId == 9) {
				item.Condit = [
					{
						label: '等于',
						value: 'eq'
					}
				];

				//加载当前题目选项
				if (q.optionList.length > 0) {
					item.optionList = q.optionList;
				}
			} else {
				item.Condit = [
					{
						label: '大于',
						value: 'ge'
					},
					{
						label: '小于',
						value: 'le'
					},
					{
						label: '等于',
						value: 'eq'
					}
				];
			}

			/* if(item.questionsTypeId == 2 || item.questionsTypeId == 3 || item.questionsTypeId == 5){
                // for(let i=0;i<item.optionList.length;i++){
                //     this.value.push()
                // }
              }*/
		},
		addDomain() {
			this.form.quotaConditionVOS.push({
				questionsId: '',
				questionsName: '',
				labelName: '',
				questionsOptionId: '',
				questionsType: '',
				quotaCondition: '',
				quotaValue: '', //如果是填空题，存储填空题结果
				optionList: [], // 当前题目的选项
				Condit: [
					{
						label: '大于',
						value: 'ge'
					},
					{
						label: '小于',
						value: 'le'
					},
					{
						label: '等于',
						value: 'eq'
					}
				],
				key: Date.now()
			});
			this.indexx++;
		},
		removeDomain(item) {
			var index = this.form.quotaConditionVOS.indexOf(item);
			if (index !== -1) {
				this.form.quotaConditionVOS.splice(index, 1);
			}
			this.indexx--;
		},
		loadAllQuestion() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryQuotaQuestions}`,
				method: 'POST',
				data: {
					id: that.wid
				},
				cb(res) {
					if (res.code == 0) {
						that.choQuestion = res.resultBody.datas;
						console.log('查询可配额的信息', res);
					}
				}
			};
			this.$util.request(params);
		},
		// 判断输入的值只能是数字
		judgeNum(num) {
			var numReg = /^[0-9]*$/;
			var numRe = new RegExp(numReg);
			if (!numRe.test(num)) {
				this.$message.error('限制数量只能输入数字！');
				return;
			}
		},
		onSubmit() {
			let that = this;
			var numReg = /^[0-9]*$/;
			var numRe = new RegExp(numReg);
			if (!numRe.test(that.form.quotaNumber)) {
				this.$message.error('限制数量只能输入数字！');
				return;
			}
			// 判断配额选项条件是否为空
			if (that.form.quotaConditionVOS.length > 0) {
				for (var i = 0; i < that.form.quotaConditionVOS.length; i++) {
					var item = that.form.quotaConditionVOS[i];
					if (item.questionsId.length <= 0 || item.quotaCondition.length <= 0 || (item.questionsOptionId.length <= 0 && item.quotaValue.length <= 0)) {
						this.$message.error('第' + (i + 1) + '行数据录入不完整，请重新设置！');
						return;
					}
				}
			} else {
				this.$message.error('当前配额没有设置条件！');
				return;
			}

			that.form.questionnaireId = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.saveQuota}`,
				method: 'POST',
				data: that.form,
				cb(res) {
					if (res.code == 0) {
						that.hiden = false;
						that.loadQuotaListData();
					}
				}
			};
			this.$util.request(params);
		},
		close() {
			this.hiden = false;
		},
		addQuota() {
			this.$forceUpdate();
			this.hiden = true;
			this.title = '添加配额';
			this.form = {
				id: '',
				questionnaireId: '',
				quotaName: '',
				quotaDescribe: '',
				quotaNumber: '',
				quotaConditionVOS: [
					{
						questionsId: '',
						questionsName: '',
						labelName: '',
						questionsOptionId: '',
						questionsType: '',
						quotaCondition: '',
						quotaValue: '', //如果是填空题，存储填空题结果
						optionList: [], // 当前题目的选项
						Condit: [
							{
								label: '大于',
								value: 'ge'
							},
							{
								label: '小于',
								value: 'le'
							},
							{
								label: '等于',
								value: 'eq'
							}
						]
					}
				]
			};
		},
		backQuota() {
			this.$router.push('/questionSetting');
		},
		loadQuotaListData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllQuota}`,
				method: 'POST',
				data: {
					id: that.wid
				},
				cb(res) {
					if (res.code == 0) {
						that.quotaData = res.resultBody.datas;
						that.total = that.quotaData.length;
						console.log('获取有无配额', res);
					} else if (res.code == 1001) {
						that.quotaData = res.resultBody.datas;
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped>
.details .demo-form-inline .quotaTextThree .choiceValue .choiceValue_input {
	width: 140px;
}
.choiceValue {
	float: left;
	margin-left: 20px;
}
.choiceCondit .choiceCondit_select {
	width: 140px;
}
.choiceCondit {
	float: left;
	margin-left: 20px;
}
.choiceQuestion .el-input__inner {
	width: 180px;
}
.choiceQuestion {
	margin-left: 20px;
	float: left;
}
.details .demo-form-inline .quotaTextarea .quotaTextarea__inner {
	width: 578px;
}
.details .demo-form-inline .quotaNumber {
	margin-right: 0px;
}
.details .demo-form-inline .quotaNumber .quotaNumber__inner {
	width: 160px;
}
.details .demo-form-inline .quotaName .quotaName_input {
	width: 320px;
}

.mask {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 1001;
	width: 100%;
	height: 100%;
	background-color: #000;
	opacity: 0.3;
}
.details {
	/* // 遮罩层内容 */
	position: fixed;
	background: #fff;
	width: 700px;
	height: 424px;
	overflow: auto;
	opacity: 1;
	z-index: 2001;
	top: 27%; /*偏移*/
	left: 47%;
	margin-left: -300px;
}
.details-1 {
	width: 100%;
	height: 60px;
	line-height: 60px;
	background: #fff;
	position: relative;
	color: #333;
	font-size: 18px;
	text-align: center;
}
.details-1 i {
	color: #999;
	position: absolute;
	right: 20px;
	top: 34%;
}

.empty_box {
	width: 1160px;
	height: 100px;
	background-color: #ffffff;
	border-radius: 3px;
	margin-top: 14px;
}
.quota {
	width: 100%;
	height: 100%;
	background-color: #f5f5f5;
}
.quota_box {
	width: 1160px;
	height: auto;
	margin: 0 auto;
	padding-top: 25px;
	/* border:1px solid red; */
}
</style>
